<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="isDisabled" [multiple]="multiple"
           [placeholder]="'organization-select.choose' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.organization.id"> {{op.organization.title | uiLabel}}</ng-option>
</ng-select>
